export const findMainCategory = (category, categories) => {
    for (const mainCategory in categories) {
        if (mainCategory === category) {
            return mainCategory;
        }
        const subcategories = categories[mainCategory];
        for (const subcategory of subcategories) {
            const result = searchSubcategory(subcategory, category);
            if (result) {
                return mainCategory;
            }
        }
    }
    return null;
};

const searchSubcategory = (subcategory, category) => {
    if (subcategory.name === category) {
        return true;
    }
    if (subcategory.subcategories) {
        for (const subSubcategory of subcategory.subcategories) {
            if (typeof subSubcategory === 'string') {
                if (subSubcategory === category) {
                    return true;
                }
            } else if (typeof subSubcategory === 'object') {
                const result = searchSubcategory(subSubcategory, category);
                if (result) {
                    return true;
                }
            }
        }
    }
    return false;
};
